/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ReassignKind;
(function (ReassignKind) {
    ReassignKind[ReassignKind["NUMBER_0"] = 0] = "NUMBER_0";
    ReassignKind[ReassignKind["NUMBER_1"] = 1] = "NUMBER_1";
})(ReassignKind || (ReassignKind = {}));
export function ReassignKindFromJSON(json) {
    return ReassignKindFromJSONTyped(json, false);
}
export function ReassignKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ReassignKindToJSON(value) {
    return value;
}
